// @ts-nocheck
import isApiError from "@insite/client-framework/Common/isApiError";
import { SafeDictionary } from "@insite/client-framework/Common/Types";
import { ApiParameter, post, ServiceResult } from "@insite/client-framework/Services/ApiService";
import { BaseModel } from "@insite/client-framework/Types/ApiModels";

interface ConfigurationOption {
    id: string;
    productId: string;
    name: string;
    description: string;
    price: number;
    selected: boolean;
    sortOrder: number;
    quantity: number;
    cantBuy: boolean;
}
interface ConfigSection {
    id: string;
    sectionName: string;
    label: string;
    sortOrder: number;
    sectionOptions: ConfigurationOption[];
}
interface Configuration {
    configSections: ConfigSection[];
    hasDefaults: boolean;
    isKit: boolean;
}

export interface FilterConfigurationApiParameter extends ApiParameter {
    productId: string;
    KitId: string;
    CurrentBtu: string;
    MaxBtu: string;
    Voltage: string;
    ConfigurationSelection?: SafeDictionary<string>;
    Configuration?: Configuration;
    Availability?: string;
}

export interface FilteredConfigurationModel extends BaseModel {
    kitId: string;
    currentBtu: string;
    maxBtu: string;
    voltage: string;
    configurationSelection?: SafeDictionary<string>;
    configuration?: Configuration;
    availability?: { [key: string]: string };
}

const configurationUrl = "api/v2/products/configurator";

const swapEmptyGuids = (obj: SafeDictionary<string>): SafeDictionary<string> => {
    const newObj = { ...obj };
    for (const key in newObj) {
        if (newObj[key] === "") {
            newObj[key] = "00000000-0000-0000-0000-000000000000";
        }
    }
    return newObj;
};

export async function filterConfiguration(
    parameter: FilterConfigurationApiParameter,
): Promise<ServiceResult<FilteredConfigurationModel>> {
    if (!parameter.ConfigurationSelection) {
        return {
            successful: false,
            errorMessage: "No configuration found",
        };
    }
    const configurationOptions = {
        KitId: parameter.productId,
        CurrentBtu: "0",
        MaxBtu: "0",
        Voltage: "",
        ConfigurationSelection: swapEmptyGuids(parameter.ConfigurationSelection),
    } as FilterConfigurationApiParameter;
    try {
        const configurationModel = await post<FilterConfigurationApiParameter, FilteredConfigurationModel>(
            `${configurationUrl}/filter`,
            configurationOptions,
        );
        return {
            successful: true,
            result: configurationModel,
        };
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        if (error.status === 403) {
            return {
                successful: false,
                errorMessage: error.errorMessage,
                statusCode: 403,
            };
        }
        throw error;
    }
}
